import React, { useEffect, useState } from "react";
import { AccountLayout } from "./accountUi";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import obj from "../../Utils/helpers";
import { PageShell, TableCard, thStyle, tdStyle, EntriesHeader, Pager } from "./accountUi";

/* Password History — reference kingexch111.com/password-history.
 * Sourced from the activity log (entries with "Password Changed"). */

const PasswordHistory = () => {
  const [limit, setLimit] = useState(10);
  const [rows, setRows] = useState([]);

  const fetchData = async () => {
    const { status, data } = await apiGet(apiPath.activityLogs, { page: 1, limit: 200 });
    if (status === 200 && data?.success) {
      const all = data?.results?.data || [];
      setRows(all.filter((a) => (a?.activityStatus || "").toLowerCase().includes("password")));
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const visible = rows.slice(0, limit);

  return (
    <AccountLayout>
      <PageShell>
        <div style={{ padding: "10px 10px 0" }} />
        <TableCard title="Password Change History">
          <EntriesHeader limit={limit} setLimit={setLimit} />
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={thStyle}>Date/Time</th>
                <th style={thStyle}>Remark</th>
              </tr>
            </thead>
            <tbody>
              {visible.length > 0 ? (
                visible.map((r, i) => (
                  <tr key={i}>
                    <td style={tdStyle}>{obj.dateFormat(r?.activityDate || r?.createdAt)}</td>
                    <td style={tdStyle}>{r?.remark || r?.activityStatus || "Password Changed"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td style={tdStyle} colSpan={2}>
                    No data available in table
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <Pager showingText={`Showing ${visible.length === 0 ? 0 : 1} to ${visible.length} of ${rows.length} entries`} />
        </TableCard>
      </PageShell>
    </AccountLayout>
  );
};

export default PasswordHistory;
